import type { LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import MandatEmisApresPaiementPanel from '../../panel/InformationsRattachement/MandatEmisApresPaiementPanel';
import NumeroEmpruntPanel from '../../panel/NumeroEmpruntPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';

class ProfilEcritureEmpruntEmisApresPaiementDepense extends BaseProfilRattachement {
  constructor(anneeExercice: number) {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.LIEE_EMPRUNT_EMISE_AP_PAIEMENT;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.EMPRUNT;
    this.typePiece = TYPE_PIECE.DEPENSE.EMIS_APRES_PAIE;
    this.imputation.articles = ['164', '6611'];
    this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE];
    this.naturePieceOrigine = NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.CODE;
    this.exerRattachement = anneeExercice?.toString();
    this.idLigneOriginePes = 0;
    this.panels = [
      new CompteDeTiersPanel(),
      new MandatEmisApresPaiementPanel(true),
      new NumeroEmpruntPanel(true),
    ];
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (parseInt(ligne.exerRattachement, 10) > parseInt(this.exerRattachement, 10)) {
      errors.push({
        id: 'mouvement-exerRattachement',
        message: "L'exercice de rattachement doit correspondre à un exercice antérieur ou égal à celui du mouvement",
      });
    }

    if (ligne.idLigneOriginePes !== 0) {
      errors.push({
        id: `ligneMouvement-idLigneOriginePes-${ligne?.identifiant}`,
        message: "L'identifiant de la ligne d'origine PES doit être égal à 0",
      });
    }

    return errors;
  }
}

export default ProfilEcritureEmpruntEmisApresPaiementDepense;
